import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import initialState from "./initial";
import { updateObjectState, updateArrayState } from "../utils";
import log from "../../utils/log";

const useEstampStore = create(
  persist(
    immer((set, get) => ({
      ...initialState, // Spread the initial state
      /**
       * Updates the cache of estamps in the state.
       * @param {string} action - The action to perform on the cache. Possible values: "whole" "update" "delete"
       * @param {string} query - query URL. eg: ?pagination=1
       * @param {Array} param - An array containing the estamp object(s) to be added, updated, or deleted.
       */
      updateEstampsCache: (action, query, param) => {
        set({ estampsCache: updateObjectState(get().estampsCache, action, { [query]: param }) });
      },
      /**
       * Updates the cache of a single estamp in the state.
       * @param {string} action - The action to perform on the cache. Possible values: "whole" "update" "delete"
       * @param {Array} param - An array containing the estamp object(s) to be added, updated, or deleted.
       */
      updateSingleEstampCache: (action, param) => {
        set({ singleEstampCache: updateArrayState(get().singleEstampCache, action, param) });
      },
      resetEstamp: () => set(initialState), // Reset function
      //getter
      getEstamps: (query) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return [obj] if has cache of provided query
        return get().estampsCache[query];
      },
      getSingleEstamp: (id) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return obj if has cache of provided id
        if (!id) {
          return undefined;
        }
        return get().singleEstampCache.find((e) => e.id === id);
      },
    })),
    {
      name: "pearl-estamp", //name of store, must be unique
      storage: createJSONStorage(() => sessionStorage), // Use session storage
    }
  )
);

export default useEstampStore;
